import { getContract } from "@/api/liveRequest/login";
import { getParameter } from "@/utils/global";

export const SET_IS_HIDDEN_BRAND = 'SET_IS_HIDDEN_BRAND'
export const SET_IS_NOT_DISTURB = 'SET_IS_NOT_DISTURB'
export const CLOUD_LIVE_SESSION_IS_HIDDEN_BRAND = 'CLOUD_LIVE_SESSION_IS_HIDDEN_BRAND'
export const CLOUD_LIVE_SESSION_IS_NOT__DISTURB = 'CLOUD_LIVE_SESSION_IS_NOT__DISTURB'
export const DEFAULT_LIVE_CID = 'DEFAULT_LIVE_CID'

// 直播相关
let defaultInfo = {
  state: {
    liveId: getParameter("liveId"),
    leftToolType: 0, //左侧工具类型 0->文档 1->白板 2->共享 3->多媒体 4
    sid: null,
    isCheck: false, //是否显示检测页面
    firstInit: true,
    isShowMix: false, //是否订阅远端流
    ccWebsocketClient: null,
    userInfo: null, //当前登录用户信息
    chatRoomId: null, //
    isShowAsideTool: false,
    isShowSign: false,
    isShowLuck: false,
    isShowPasswordLuck: false,
    isShowCurt: false,
    isShowGroup: false,
    isShowPseudo: false,
    isShowAnswer: false,
    isShowAnswerSheet: false,
    isShowGoods: false,
    isShowCement: false,
    isShowCountDown: false,
    isShowRedPacket:false,
    isShowRedPacketRecord:false,//红包记录
    isShowRedPacketDetail:false,//红包详情
    isShowRecommend: false,
    shareType: -1,
    isPackUp:false, //是否收起
    isChangeArea:false,//是否交换视频和文档区域
    isLeave:false,
    logInfo:{
      roomId:null,
      userId:null,
      userName:null,
      development:process.env.ENV,
      platform:'web_cla_anchor',
      logName:'web云播2.0主播嘉宾端',
      liveId:getParameter("liveId")
    },
    signalStatus: 0, // 0:较号 1：较弱 2：最弱
    signalTimer: null,
    contract: undefined, // 合同信息
    setting: false,
    isHiddenBrand: sessionStorage.getItem(CLOUD_LIVE_SESSION_IS_HIDDEN_BRAND) || 'false',
    isNotDisturb: sessionStorage.getItem(CLOUD_LIVE_SESSION_IS_NOT__DISTURB) || '',
    configInfo: sessionStorage.getItem('configInfo') || '',
    defaultLiveCid: sessionStorage.getItem(DEFAULT_LIVE_CID) || '',
    teamId: '0', //组id，默认空给所有
    groupOrder: "",
    loginPageLogo: "",
    loginPageBackground: "",
    joinRoom: false,
    inputInstant: 0,
    ischangeVideo: false,
  },
  mutations: {
    SET_ISCHANGEVIDEO(state, data) {
      state.ischangeVideo = data;
    },
    SET_INPUTINSTANT(state, data) {
      state.inputInstant = data;
    },
    SET_LEFTTOOLTYPE(state, data) {
      state.leftToolType = data;
    },
    SET_SID(state, data) {
      state.sid = data;
    },
    SET_JION_ROOM(state, data) {
      state.joinRoom = data;
    },
    SET_ISCHECK(state, data) {
      state.isCheck = data;
    },
    SET_FIRSTINIT(state, data) {
      state.firstInit = data;
    },
    SET_ISSHOWMIX(state, data) {
      state.isShowMix = data;
    },
    SET_CCWEBSOCKETCLIENT(state, data) {
      state.ccWebsocketClient = data;
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
    },
    SET_CHATROOMID(state, data) {
      state.chatRoomId = data;
    },
    // 工具
    SET_SHOW_ASIDE_TOOL(state, data) {
      state.isShowAsideTool = typeof data === "boolean" ? data : !state.isShowAsideTool
    },
    // 签到
    SET_SHOW_SIGN(state, data) {
      state.isShowSign = data
    },
    // 抽奖
    SET_SHOW_LUCK(state, data) {
      state.isShowLuck = data
    },
    // 口令抽奖
    SET_SHOW_PASSWORD_LUCK(state, data) {
      state.isShowPasswordLuck = data
    },
    // 多媒体
    SET_SHOW_INCURT(state, data) {
      state.isShowCurt = data
    },
    //分组
    SET_SHOW_GROUP(state, data){
      state.isShowGroup = data
    },
    // 伪直播
    SET_SHOW_PSEUDO(state, data) {
      state.isShowPseudo = data
    },
    /**
     * 问卷
     * @param {*} state
     * @param {*} data
     */
    SET_SHOW_ANSWER(state, data) {
      state.isShowAnswer = data;
    },
    /**
     * 答题
     * @param {*} state
     * @param {*} data
     */
    SET_SHOW_ANSWERSHEET(state, data) {
      state.isShowAnswerSheet = data;
    },
    // 商品
    SET_SHOW_GOODS(state, data) {
      state.isShowGoods = data
    },
    //推荐
    SET_SHOW_RECOMMEND(state, data) {
      state.isShowRecommend = data;
    },
    // 公告
    SET_SHOW_CEMENT(state, data) {
      state.isShowCement = data
    },
    // 倒计时
    SET_SHOW_COUNT_DOWN(state, data) {
      state.isShowCountDown = data
    },
    // 红包
    SET_SHOW_RED_PACKET(state, data) {
      state.isShowRedPacket = data
    },
    // 红包记录
    SET_SHOW_RED_PACKET_RECORD(state, data){
      state.isShowRedPacketRecord = data
    },
    SET_SHOW_RED_PACKEY_DETAIL(state, data){
      state.isShowRedPacketDetail = data
    },
    SET_GROUP_ID(state, data){
      state.teamId = data
    },
    // 设置当前共享类型 0 文档 1 白板 2 桌面共享 3 插播 4 伪直播
    SET_SHARE_TYPE(state, data) {
      state.shareType = data
    },
    SET_ISPACKUP(state, data){
      state.isPackUp = data
    },
    SET_ISCHANGEAREA(state, data){
     state.isChangeArea = data
    },
    SET_SET_LOGO(state, data){
      state.loginPageLogo = data
    },
    SET_SET_BACKGROUND(state, data){
      state.loginPageBackground = data
    },
    SET_ISLEAVE(state, data){
      state.isLeave = data
    },
    // logInfo
    SET_LOGINFO(state,data){
      state.logInfo = data
    },
    // 信号质量
    SET_SIGNAL_STATUS(state, data) {
      if (state.signalStatus !== 0) return
      if (state.signalTimer) clearTimeout(state.signalTimer)
      state.signalTimer = setTimeout(() => {
        state.signalStatus = data
        console.warn('signal::', data);
      }, 10000)
    },
    SET_CONTRACT(state, data) {
      state.contract = data
    },
    SHOW_SETTING(state, data) {
      state.setting = data
    },
    [SET_IS_HIDDEN_BRAND](state, data) {
      state.isHiddenBrand = data
      sessionStorage.setItem(CLOUD_LIVE_SESSION_IS_HIDDEN_BRAND, data)
    },
    [SET_IS_NOT_DISTURB](state, data) {
      state.isNotDisturb = data
      sessionStorage.setItem(CLOUD_LIVE_SESSION_IS_NOT__DISTURB, data)
    },
    setConfigInfo(state, data) {
      state.configInfo = data
      sessionStorage.setItem('configInfo', JSON.stringify(data))
    },
    SET_DEFAULT_LIVE_CID(state, data) {
      state.defaultLiveCid = data
      sessionStorage.setItem(DEFAULT_LIVE_CID, data)
    },
    SET_GROUP_ORDER(state, data) {
      state.groupOrder = data
    }
  },
  actions: {
    async GET_CONTRACT({state, commit}) {
      try {
        const { code, data } = await getContract(state.liveId)
        if (code === 200) {
          commit("SET_CONTRACT", data)
          return data
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
export default defaultInfo;
